import { computed } from 'vue'
import { useContentPreloaderStore } from '@white-label-store/content-preloader';

export function useContentPreloader() {
  const store = useContentPreloaderStore()

  const contentPreloaderEnabled = computed(() => store.enabled)

  const enableContentPreloader = () => store.updateStatus(true)
  const disableContentPreloader = () => store.updateStatus(false)

  return {
    contentPreloaderEnabled,
    enableContentPreloader,
    disableContentPreloader,
  }
}
